/**
 * Lab-module settings API.
 *
 * A single per-org flag: enable_lab_module. When false (the default) the Lab
 * module is off and the app behaves exactly as today.
 *
 * Backend: GET / PUT /api/organisation/settings/lab
 */
import apiClient from './apiClient';

export const getLabSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/lab');
  return res.data;
};

export const updateLabSettings = async (enable_lab_module) => {
  const res = await apiClient.put('/api/organisation/settings/lab', {
    enable_lab_module,
  });
  return res.data;
};
